/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserExcludingFcmMessageIdFcmTokenWithRelations } from './userExcludingFcmMessageIdFcmTokenWithRelations';
import { CompanyExcludingFcmMessageIdFcmTokenWithRelations } from './companyExcludingFcmMessageIdFcmTokenWithRelations';


/**
 * (tsType: Omit<HumanCapitalCompanyWithRelations, \'fcmMessageId\' | \'fcmToken\'>, schemaOptions: { includeRelations: true, exclude: [ \'fcmMessageId\', \'fcmToken\' ] })
 */
export interface HumanCapitalCompanyExcludingFcmMessageIdFcmTokenWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    humanCapitalManagerId?: number;
    humanCapitalDirectorId?: number;
    companyId?: string;
    payrollManagerId?: number;
    generalManagerId?: number;
    compensationManagerId?: number;
    payrollStaffId?: number;
    humanCapitalStaffId?: number;
    humanCapitalStaff2Id?: number;
    humanCapitalManager?: UserExcludingFcmMessageIdFcmTokenWithRelations;
    humanCapitalDirector?: UserExcludingFcmMessageIdFcmTokenWithRelations;
    company?: CompanyExcludingFcmMessageIdFcmTokenWithRelations;
    payrollManager?: UserExcludingFcmMessageIdFcmTokenWithRelations;
    generalManager?: UserExcludingFcmMessageIdFcmTokenWithRelations;
    compensationManager?: UserExcludingFcmMessageIdFcmTokenWithRelations;
    payrollStaff?: UserExcludingFcmMessageIdFcmTokenWithRelations;
    humanCapitalStaff?: UserExcludingFcmMessageIdFcmTokenWithRelations;
    humanCapitalStaff2?: UserExcludingFcmMessageIdFcmTokenWithRelations;
}

